export default __webpack_public_path__ + "static/bidra-i-figma7-af999c3427885a61967dc62b8a5c988f.png";